import React from "react";
import { MetaPixel } from "./components/MetaPixel";
import { FloatingCTA } from "./components/FloatingCTA";
import { PurchasePopup } from "./components/PurchasePopup";
import { Hero } from "./components/sections/Hero";
import { Problem } from "./components/sections/Problem";
import { Transformation } from "./components/sections/Transformation";
import { Pains } from "./components/sections/Pains";
import { Volumes } from "./components/sections/Volumes";
import { Resources } from "./components/sections/Resources";
import { Bonuses } from "./components/sections/Bonuses";
import { Offer } from "./components/sections/Offer";
import { Guarantee } from "./components/sections/Guarantee";
import { Testimonials } from "./components/sections/Testimonials";
import { About } from "./components/sections/About";
import { FAQ } from "./components/sections/FAQ";
import { FinalCTA } from "./components/sections/FinalCTA";
import { Footer } from "./components/sections/Footer";
export function App() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-ink font-sans antialiased" data-id="element-0" data-mp="3ikqwhsrnks2k">
      <MetaPixel data-id="element-1" data-mp="3mkrd9k285fcs" />
      <Hero data-id="element-2" data-mp="3mk86mzi0yde2" />
      <main data-id="element-3" data-mp="3mjzu58ptda3e">
        <Problem data-id="element-4" data-mp="3mjg9vlcoy9m7" />
        <Transformation data-id="element-5" data-mp="3rc9em985thya" />
        <Pains data-id="element-6" data-mp="3rbrc4uuwm7hx" />
        <Volumes data-id="element-7" data-mp="3rdaselgk8ijp" />
        <Resources data-id="element-8" data-mp="3rcswjpxt86cb" />
        <Bonuses data-id="element-9" data-mp="3recctgjguhe3" />
        <Offer data-id="element-10" data-mp="5yhgo69t1c8" />
        <Guarantee data-id="element-11" data-mp="6hovayao7c0" />
        <Testimonials data-id="element-12" data-mp="4ww9qvjiygs" />
        <About data-id="element-13" data-mp="56mnfkhz7n0" />
        <FAQ data-id="element-14" data-mp="7su7f7e1n58" />
        <FinalCTA data-id="element-15" data-mp="2zl3c5m4yv85u" />
      </main>
      <Footer data-id="element-16" data-mp="2zlv32jnmchps" />
      <FloatingCTA data-id="element-17" data-mp="2zmenc70qri6z" />
      <PurchasePopup data-id="element-18" data-mp="2zmwlj96ys6hj" />
    </div>;
}